<div class="pseic-toaster-background pseic-toaster-background-{{messageType}} pseic-toaster">
    <div
        class="pseic-toaster-icon"
        (click)="closeComponent()"
    >
        <psei-icon
            name="close"
            [size]="iconSize"
        ></psei-icon>
    </div>
    <div class="pseic-toaster-container">
        <div class="pseic-toaster-type-icon">
            <psei-icon
            [name]="iconName"
            [size]="typeIconSize"
        ></psei-icon>
        </div>
        <div
            class="pseic-toaster-message"
            [innerHTML]="message"
        >
        </div>
    </div>
</div>